import { useEffect, useState } from "react";
import "./BackToTop.css";
import arrowUp from "../assets/icons/arrow-up-long-line.svg";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  // Button immer rendern, CSS regelt fade in/out
  return (
    <button
      className={`back-to-top ${visible ? "show" : ""}`}
      onClick={scrollToTop}
    >
      <img src={arrowUp} alt="Pfeil nach oben" />
    </button>
  );
}

export default BackToTop;
